import { cva, VariantProps } from "class-variance-authority";

export const tabsVariants = cva(["flex overflow-hidden relative"], {
  variants: {
    variant: {
      button: [""],
    },
    size: {
      "26": ["gap-x-1", "rounded-lg"],
      "33": ["gap-x-1 rounded-xl"],
      "38": ["gap-x-2.5 rounded-2xl"],
    },
    color: {
      spearmint: [],
      ultramarineBlue: [],
    },
  },
  defaultVariants: {
    variant: "button",
    size: "38",
  },
});

export type TabsVariantProps = VariantProps<typeof tabsVariants>;

export const tabVariants = cva(
  [
    "relative inline-flex justify-center cursor-pointer items-center outline-hidden transition-colors",
  ],
  {
    variants: {
      variant: {
        button: ["rounded-md"],
      },
      color: {
        spearmint: ["bg-nobel/5 text-nobel"],
        ultramarineBlue: ["bg-nobel/10 text-nobel"],
      },
      size: {
        "26": ["text-sm leading-none p-1.5 rounded"],
        "33": ["text-sm leading-none px-3 py-2.5 rounded-md"],
        "38": ["leading-none pl-3 pr-4 py-2.5 gap-x-2"],
      },
      active: {
        true: null,
        false: null,
      },
    },
    defaultVariants: {
      variant: "button",
      color: "spearmint",
      size: "38",
    },
    compoundVariants: [
      {
        variant: "button",
        color: "spearmint",
        active: true,
        className: "text-spearmint bg-transparent",
      },
      {
        variant: "button",
        color: "ultramarineBlue",
        active: true,
        className: "text-ultramarine-blue bg-transparent",
      },
    ],
  }
);

export const activeElementVariants = cva(["absolute"], {
  variants: {
    variant: {
      button: [
        "inset-0 h-full w-full -z-10  overflow-hidden rounded-md bg-spearmint/10",
      ],
    },
    color: {
      spearmint: ["bg-spearmint/10"],
      ultramarineBlue: ["bg-ultramarine-blue/10"],
    },
  },
  defaultVariants: {
    variant: "button",
    color: "spearmint",
  },
});
